<script setup lang="ts">
import { PV } from "@/widgets";
import { onMounted, ref } from "vue";
import { RouterLink, useRouter } from "vue-router";

const props = defineProps<{
    prev?: string;
    title: string;
    subtitle?: string;
}>();

const router = useRouter();
const back = ref<string>();
const to = ref("/");

onMounted(() => {
    back.value = router.options.history.state.back?.toString();
    to.value = back.value ?? props.prev ?? "/";
});
</script>

<template>
    <div
        class="flex flex-col md:flex-row p-6 items-center justify-between gap-4 md:gap-0 bg-linear-to-r from-blue-500 to-cyan-500 shadow-xs"
    >
        <div class="w-full flex flex-row gap-2 items-center">
            <RouterLink v-if="back === undefined" :to="to">
                <PV.Button v-tooltip.bottom="'Kembali'" class="text-white!" icon="pi pi-chevron-left" link />
            </RouterLink>
            <PV.Button
                v-else
                v-tooltip.bottom="'Kembali'"
                class="text-white!"
                icon="pi pi-chevron-left"
                link
                @click="() => router.back()"
            />
            <div v-if="props.subtitle !== undefined" class="flex flex-col gap-1">
                <h1 class="text-3xl font-semibold text-white">{{ props.title }}</h1>
                <h1 class="font-medium text-white">{{ props.subtitle }}</h1>
            </div>
            <h1 v-else class="text-3xl font-semibold text-white">{{ props.title }}</h1>
        </div>
        <div class="w-full pl-8 md:pl-0 flex flex-row justify-end">
            <slot></slot>
        </div>
    </div>
</template>
